import Product from "../../../../../@types/Product";

const WindShields: Product[] = [
    {
        id: 1,
        name: 'Folding Windshield - Clear',
        sku: '09-208',
        price: 0.00,
        retailPrice: 0.00,
    },
    /* {
        id: 2,
        name: 'Folding Windshield - Tinted',
        sku: '09-183',
        img: `${process.env.PUBLIC_URL}/windshields/windshield-tint-300x300.jpg`,
        price: 130.00,
        retailPrice: 1.00,
    } */
    {
        id: 3,
        name: 'Folding Windshield - Clear',
        sku: 'None',
        price: 0.00,
        retailPrice: 0.00,
    },
]

export default WindShields;